/**
 * Generates a unique identifier based on the current timestamp and a random number.
 *
 * @returns {number} A numeric ID combining the current time and a random decimal.
 */
export function getRandomId(): number {
  return Date.now() + Math.random()
}
